import React, { useState } from "react";
import ContactUsBanner from "../assets/img/icons/contact-us.png";
import RunningGuy from "../assets/img/general/aboutus.png";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { RestfullApiService } from "../config/service";
import toast from "react-hot-toast";

const ContactUs = () => {
  const [submitForm, setSubmitForm] = useState(false);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const submitContactUs = async (values, resetForm) => {
    const reqdata = {
      Method_Name: "Create",
      ...values,
    };
    try {
      setSubmitForm(true);
      const result = await RestfullApiService(reqdata, "participant/contactus");

      if (result?.status === 200) {
        toast.success("Your message has been sent successfully!");
        resetForm();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitForm(false);
    }
  };
  return (
    <>
      <section className="py-5 d-flex items-center bg-blue-1-05 mt-80">
        <div className="container">
          <div className="row y-gap-10 items-center justify-between font-inter">
            <div className="col-auto">
              <div className="row x-gap-10 y-gap-5 items-center text-14 text-light-1">
                <div className="col-auto">
                  <div className="">Home</div>
                </div>
                <div className="col-auto">
                  <div className="">|</div>
                </div>
                <div className="col-auto">
                  <div className="text-primary">Contact us</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pt-md layout-pb-md relative">
        <div className="container">
          <div
            className="abt-card shadow-2 rounded-16 px-50 lg:px-20 py-25 bg-white relative"
            style={{ zindex: "2" }}
          >
            <div className="row y-gap-30 justify-between items-center">
              <div className="col-lg-6">
                <img
                  src={ContactUsBanner}
                  alt="contact-us"
                  className="rounded-8"
                  style={{ width: "80%", height: "70%" }}
                />
              </div>
              <div className="col-lg-6 px-30 lg:px-10">
                <h2 className="text-24 fw-700 text-primary mt-10">
                  Request a call back
                </h2>
                <Formik
                  initialValues={{
                    Name: "",
                    Phone: "",
                    Email: "",
                    Message: "",
                  }}
                  validationSchema={Yup.object({
                    Name: Yup.string()
                      .matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Invalid format")
                      .required("Name is required"),
                    Phone: Yup.string()
                      .matches(/^[0-9]+$/, "Phone number is not valid")
                      .required("Phone number is required"),
                    Email: Yup.string()
                      .matches(emailRegex, "Invalid email address")
                      .required("Email is required"),
                    Message: Yup.string().required("Message is required"),
                  })}
                  onSubmit={(values, { resetForm }) => {
                    console.log("Form values", values);
                    submitContactUs(values, resetForm);

                    // Reset the form fields
                    //   resetForm();
                  }}
                >
                  {({ errors, touched, setFieldValue }) => (
                    <Form className="mt-30">
                      <div className="single-field mb-20">
                        <div className="form-control">
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Name*"
                            name="Name"
                            onChange={(e) => {
                              e.preventDefault();
                              const { value } = e.target;

                              const regex = /^[a-zA-Z][a-zA-Z\s]*$/;

                              if (!value || regex.test(value.toString())) {
                                setFieldValue("Name", value);
                              } else {
                                return;
                              }
                            }}
                          />
                        </div>
                        {errors.Name && touched.Name && (
                          <div className="text-error-2 text-13">
                            {errors.Name}
                          </div>
                        )}
                      </div>

                      <div className="single-field mb-20">
                        <div className="form-control">
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Phone*"
                            name="Phone"
                            maxLength="10"
                            onChange={(e) => {
                              e.preventDefault();
                              const { value } = e.target;

                              // Regular expression to allow only numbers
                              const regex = /^[0-9\b]+$/;

                              if (!value || regex.test(value.toString())) {
                                setFieldValue("Phone", value);
                              } else {
                                return;
                              }
                            }}
                          />
                        </div>
                        {errors.Phone && touched.Phone && (
                          <div className="text-error-2 text-13">
                            {errors.Phone}
                          </div>
                        )}
                      </div>

                      <div className="single-field mb-20">
                        <div className="form-control">
                          <Field
                            type="text"
                            className="form-control"
                            placeholder="Email*"
                            name="Email"
                          />
                        </div>
                        {errors.Email && touched.Email && (
                          <div className="text-error-2 text-13">
                            {errors.Email}
                          </div>
                        )}
                      </div>

                      <div className="single-field mb-30">
                        {/* <div className=""> */}
                        <Field
                          as="textarea"
                          rows="3"
                          className="form-control"
                          placeholder="Message"
                          name="Message"
                          style={{
                            padding: "13px 20px",
                            fontSize: "13px",
                            fontWeight: "500",
                          }}
                          onChange={(e) => {
                            e.preventDefault();
                            const { value } = e.target;

                            const regex = /^[a-zA-Z][a-zA-Z\s]*$/;

                            //  if (!value || regex.test(value.toString())) {
                            setFieldValue("Message", value);
                            //  } else {
                            //    console.log("false");
                            //    return;
                            //  }
                          }}
                        />
                        {/* </div> */}
                        {errors.Message && touched.Message && (
                          <div className="text-error-2 text-13">
                            {errors.Message}
                          </div>
                        )}
                      </div>

                      <div className="relative">
                        <button
                          type="submit"
                          disabled={submitForm}
                          className="button w-full h-50 px-20 -grey-1 bg-primary text-white rounded-100 load-button"
                        >
                          {!submitForm && "Submit"}
                          {submitForm && <span className="btn-spinner"></span>}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="layout-pt-sm layout-pb-md">
        <div class="container">
          <div class="row x-gap-80 y-gap-20 justify-between">
            {/* <div class="col-12">
              <div class="text-30 sm:text-24 fw-600">Contact Us</div>
            </div> */}

            <div class="col-lg-5">
              <div class="text-14 text-light-1">Address</div>
              <div class="text-16 fw-500 mt-10">
                Spring Groove, Village, Akurli Rd, Kandivali, Narsi Pada,
                Kandivali East, Mumbai, Maharashtra 400101
              </div>
            </div>

            <div class="col-auto">
              <div class="text-14 text-light-1">Contact Number</div>
              <div class="text-16 fw-500 mt-10">+(91) 983 311 1510 </div>
            </div>

            <div class="col-auto">
              <div class="text-14 text-light-1">Need live support?</div>
              <div class="text-16 fw-500 mt-10">marketing@fitizenindia.com</div>
              <div class="text-16 fw-500 mt-10">
                supportevents@fitizenindia.com
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
